/**
 * Waste-code validation reason strings and their message formatting, shared by
 * the compliance-engine rules and Oak's live chip validation so the inline
 * helper text and the persisted issue text can't drift apart. Like `./epaId`,
 * this is a dependency-free leaf module: Oak imports it directly without
 * pulling in the engine's encamp-shared graph.
 */

export const FEDERAL_WASTE_CODE_FORMAT_REASON =
  "Federal waste codes must be 4 characters starting with D, F, K, U, or P followed by 3 digits (e.g., D001, F005, U154)";

export const PHRM_WASTE_CODE_REASON =
  "Federal PHRM waste code requires G61 source code and W005 form code";

export const UNRECOGNIZED_STATE_WASTE_CODE_REASON = "not a recognized state waste code";

export const OUTS_WASTE_CODE_REASON = "out-of-state (OUTS) codes can't be filed";

export const UNRECOGNIZED_WASTE_CODE_REASON = "not a recognized federal or state waste code";

/**
 * Formats invalid-code results into one line, grouping codes that share a
 * reason so each reason is stated once, e.g.
 * `D01, X99: <format guidance>; OUTS: <OUTS guidance>`.
 */
export function formatInvalidCodeReasons(
  invalidCodes: Array<{ code: string; reason: string }>
): string {
  const byReason = new Map<string, string[]>();
  for (const { code, reason } of invalidCodes) {
    byReason.set(reason, [...(byReason.get(reason) ?? []), code]);
  }
  return [...byReason.entries()]
    .map(([reason, codes]) => `${codes.join(", ")}: ${reason}`)
    .join("; ");
}
